let widgetAddConfigMixin = {
  data() {
    return {
      widgetConfig: null, // 위젯 설정 정보
      layout: [] // 선택한 대시보드 레이아웃 정보
    };
  },
  created() {},
  methods: {
    /** 레이아웃 정보 가져오기 */
    async getListWidgets(dashboardId) {
      // 위젯 목록 조회
      this.layout = [];
      await this.$http.dashboard
        .get(`/v1/console/dashboards/${dashboardId}/widgets`)
        .then((res) => {
          this.layout = res.contents.map((widget, i) => {
            widget.chartAttr = JSON.parse(widget.chartAttr);
            widget.x = widget.chartAttr.x;
            widget.y = widget.chartAttr.y;
            widget.w = widget.chartAttr.w;
            widget.h = widget.chartAttr.h;
            widget.i = i.toString();
            return widget;
          });
        });
    },

    /** 위젯 추가 */
    async onWidgetAdd(widgets) {
      await this.getListWidgets(widgets[0].dashboardId);
      const y =
        this.layout.length === 0
          ? 1
          : this.layout.map((o) => Number(o.y) + Number(o.h)).sort((a, b) => a - b)[
              this.layout.length - 1
            ] + 1;

      for (let i = 0; i < widgets.length; i++) {
        const config = widgets[i];
        config.chartAttr.x = 0;
        config.chartAttr.y = Number(y || 0) + Number(config.chartAttr.h) * i;
        config.chartType = config.chartAttr.widget.type;
        config.chartName = config.chartAttr.widget.type + Date.now();
        await this.createWidget(config);
      }
    },

    /** 위젯 생성 */
    async createWidget(config) {
      return await this.$http.dashboard
        .post(
          `/v1/console/dashboard-widgets`,
          {
            ...config,
            dashboardId: config.dashboardId
          },
          false,
          false
        )
        .then((res) => {
          if (res instanceof Error) {
            return;
          } else {
            window.app.$modal.open({
              rootId: 'app',
              type: 'alert',
              title: this.$t('title.notice'),
              message: this.$t('page.widget.widgetAdd'),
              action: () => {}
            });
          }
        });
    }
  }
};
export default widgetAddConfigMixin;
